export const enum StorageToken {
  accessToken = 'access_token',
  language = 'language',
  previousAccessToken = 'previous-access-token',
  masquerade = 'masquerade',
  masqueradePermissions = 'mas-permissions',
  masRefreshToken = 'Mas-refresh-token',
  masAccessToken = 'mas_access_token',
}

export const ACCESS_TOKEN_SPLIT_THRESHOLD = 3500;
